import _debounce from "lodash/debounce";
import { useCallback, useEffect, useState } from "react";
import { Input } from "semantic-ui-react";

import "components/NavBarSearch/NavBarSearch.scss";

type NavBarSearchProps = {
  value: string;
  handleSearchChange: (value: string) => void;
  debounceTime?: number;
};

const DEBOUNCE_TIME = 500;

export const NavBarSearch = ({ value, handleSearchChange, debounceTime = DEBOUNCE_TIME }: NavBarSearchProps) => {
  const [searchTerm, setSearchTerm] = useState(value);

  const debouncedHandleSearchChange = useCallback(
    _debounce(searchTerm => handleSearchChange(searchTerm), debounceTime),
    [handleSearchChange, debounceTime]
  );

  const handleOnChange = (searchText: string) => {
    setSearchTerm(searchText);
    debouncedHandleSearchChange(searchText);
  };

  useEffect(() => {
    if (value !== searchTerm) {
      setSearchTerm(value);
      debouncedHandleSearchChange(value);
    }
  }, [value]);

  return (
    <div className="NavBarSearch">
      <Input
        icon="magnifying glass"
        iconPosition="left"
        placeholder="Search..."
        className="nav-bar-search"
        onChange={e => handleOnChange(e.target.value)}
        value={searchTerm}
      />
    </div>
  );
};
